import { handleCorruptRestApi } from "@devowl-wp/utils";
import { listenAutomaticScanStarterJobExecution } from "./others/scanner/automaticScanStarter.js";
import { listenScannerJobExecution } from "./others/scanner/execute.js";
import { listenScannerStatus } from "./others/scanner/listenStatus.js";
/**
 * The entry point for the `real-queue` workers
 */ handleCorruptRestApi({
});
listenScannerJobExecution();
listenScannerStatus();
listenAutomaticScanStarterJobExecution();
